import { useFeature } from 'common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';
import { useCompanyCurrency } from 'src/core/modules/app/hooks/useCompanyCurrency';

export const useIsUkInternationalWireTransferEnabled = (): boolean => {
  const companyCurrency = useCompanyCurrency();
  return (
    useFeature(FEATURES.TMP_UK_INTERNATIONAL_WIRE_TRANSFER) &&
    companyCurrency === 'GBP'
  );
};
